import imageUrlBuilder from '@sanity/image-url';
import { sanityClient } from '../api/sanityClient';

const builder = imageUrlBuilder(sanityClient);

export function urlFor(source) {
  return builder.image(source);
}